import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTopOnNav: FC = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		const siteRoot = document.getElementById('siteRoot');
		siteRoot?.scrollTo(0, 0);
	}, [pathname]);

	return null;
};

export default ScrollToTopOnNav;
